import React from "react";
import "./LoginModal.scss";
import Modal from "react-bootstrap/Modal";
import { ReactComponent as ZixxarLogo } from "../../Assets/Global/zixxar-logo.svg";
import { ReactComponent as OldZixxarLogo } from "../../Assets/Global/old-zixxar-logo.svg";
import { ReactComponent as CloseIcon } from "../../Assets/Global/close.svg";

const LoginModal = ({ show, toggleModal }) => {
  const redirectHandler = buttonId => {
    if (buttonId === "old") window.open("https://shop.zixxar.net");
    if (buttonId === "new") window.open("https://beta.zixxar.net");
    toggleModal();
    return;
  };

  return (
    <Modal show={show} onHide={toggleModal} centered className="login-modal">
      <Modal.Header>
        <div className="w-100 d-flex justify-content-center pt-4 position-relative">
          <CloseIcon className="close-icon" onClick={toggleModal} />

          <h4 className="text-center font-size-24 font-pnb">Choose your application</h4>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 d-flex justify-content-around align-items-end mb-5">
          <button className="d-flex flex-column align-items-center account-link" onClick={() => redirectHandler("old")}>
            <OldZixxarLogo className="mb-3 old-zixxar-icon" />
            <h6 className="font-size-20 font-pnm">Old ZiXXar</h6>
          </button>
          <button className="d-flex flex-column align-items-center account-link" onClick={() => redirectHandler("new")}>
            <ZixxarLogo className="mb-3 new-zixxar-icon" />
            <h6 className="font-size-20 font-pnm">New ZiXXar</h6>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LoginModal;
